import type { PostTokenRefreshResponse } from '~/api/aspida/@types';
import { sendRequest } from '~/api/sendRequest';
import type { EmptyObject } from '~/interfaces/common';

export const postTokenRefresh = sendRequest<EmptyObject, PostTokenRefreshResponse>({
  url: '/token/refresh',
  method: 'post',
});
